<template>
    <div class="sub-page">
        <div class="block company-block">
            <dl v-for="(company, index) in companyStyleList" :key="index">
                <dt class="company-text">{{isCn?company.cnImageName:company.enImageName}}</dt>
                <dd class="company-photo">
                    <img class="vw-img" :src="company.image" alt="">
                </dd>
            </dl>
            <div class="more-row">
                <router-link :to="{name: 'spirit'}" class="btn-more">MORE<q-icon name="add"></q-icon></router-link>
            </div>
        </div>
    </div>
</template>

<script>
import getLang from '@/utils/main/lang';
import Layout from '@/views/Layout.vue';
import ajax from '@/utils/ajax';
import router from '@/router';

export default {
    name: 'company',
    components: {
        Layout,
    },
    data() {
        return {
            isCn: window.localStorage.getItem('show-lang') !== 'en',
            lang: getLang(),
            companyStyleList: [],
        };
    },
    computed: {
        flagTrans() {
            const screenWidth = window.innerWidth;
            return `${(3 - this.flagIndex) * 60 * screenWidth / 375}px`;
        },
        flagPhotoTrans() {
            const screenWidth = window.innerWidth;
            return `${-this.flagIndex * 375 * screenWidth / 375}px`;
        },
    },
    mounted() {
        const self = this;
        ajax.get('/web/homepage/homepage_list.json', {}).then((result) => {
            self.homeList = result.dataList;
            result.dataList.forEach((value) => {
                let jsonObj = null;
                try {
                    jsonObj = JSON.parse(value.jsonStr);
                    if (value.type === 'companyStyle') {
                        self.companyStyleTitle = self.isCn ? jsonObj.titleCn : jsonObj.titleEn;
                    }
                } catch (e) {
                    console.log('json error');
                }
            });
        }).catch(() => {});
        ajax.get('/web/homepage/company_style_list.json', { pageSize: 5 }).then((result) => {
            this.companyStyleList = result.dataList;
        }).catch(() => {});
    },
    methods: {
        goBack() {
            router.go(-1);
        },
    },
};
</script>
<style lang="less" scoped>
    .block {
        margin-top: 10px;
        background: #fff;
        padding: 15px;
        .block-title {
            display: block;
            padding-top: 8px;
            font-size: 14px;
            font-weight: 600;
            text-align: center;
        }
        .block-title-line {
            margin-top: 6px;
            display: block;
            margin: 0 auto;
            width: 22px;
            height: 2px;
            background: #C71F4B;
        }
    }
    .company-block {
        padding: 15px;
        .company-text {
            margin-top: 10px;
            font-size: 13px;
            line-height: 20px;
            padding: 2px 0;
            word-break: break-word;
        }
        .company-photo {
            padding-bottom: 12px;
            border-bottom: 1px solid #F1F1F1;
            width: 100%;
            .vw-img {
                margin: 0 auto;
                display: block;
                width: 345px;
                height: 133.4px;
            }
        }
    }
    .more-row {
        padding-top: 16px;
        text-align:center;
        .btn-more {
            display: inline-flex;
            justify-content: center;
            align-items: center;
            width: 90px;
            height: 28px;
            line-height: 28px;
            font-size: 12px;
            color: #4A4A4A;
            border: 1px solid #C71F4B;
        }
    }
</style>
